import { AuthToken, ModelRow, UserSettings } from "@mcleod/core";
import {
    DataSourceRemoteDataChangeEvent, ModelDataChangeType, Label, Layout, Panel, Snackbar,
    ScreenStack,
    Dialog
} from "@mcleod/components";
import { AutogenLayoutRapidAlertFeed } from "./autogen/AutogenLayoutRapidAlertFeed";
import { RapidAlertSlideout } from "./RapidAlertSlideout";

export class RapidAlertFeed extends AutogenLayoutRapidAlertFeed {
    private alertCount: number = 0; // Use a private field to store the count

    override onLoad(): void {
        const userSettings = UserSettings.get();
        if (!userSettings.enable_alerts || userSettings.system_tray === "N") {
            this.mainDataSource.removeAllEventListeners("_remoteDataChangeListeners");
            this.updateAlertCount();
        }
        else if (userSettings.enable_alerts) {
            this.updateAlertCount();
        }
    }

    sourceRapidAlertOnRemoteDataChange(event: DataSourceRemoteDataChangeEvent) {
        let changeType = event.change.type;
        const changeData = event.change.data as ModelRow;

        if (changeData.get("is_confirmed") || UserSettings.getUserId() !== changeData.get("user_id")) {
            changeType = ModelDataChangeType.DELETE;
        }

        this.sourceRapidAlert.handleDataChange({
            type: changeType,
            data: changeData,
            lastUpdateNanos: event.change.lastUpdateNanos
        });
        if (changeType == ModelDataChangeType.UPDATE) {
            const rapidAlertId = changeData.get("id");
            const existingRow: boolean = this.mainDataSource.data.some(row => row.get("id") === rapidAlertId);
            if (!existingRow) {
                this.mainDataSource.addRow(changeData);
                if (UserSettings.get().system_tray === "P") {
                    const tooltip = new Panel();
                    tooltip.add(new Label({ text:  changeData.get("alert_description") != null ? changeData.get("alert_description") : changeData.get("alert_id"),
                        margin: 0, marginLeft: 8, padding: 0, fontSize: "large" 
                    }));
                    tooltip.add(new Label({ text: changeData.get("message") }));
                    if (ScreenStack.getSnackbarTarget() instanceof Dialog) {
                        Snackbar.showSnackbar(tooltip, {targetPanel: ScreenStack.getPreviousSnackbarTarget()});
                    } else {
                        Snackbar.showSnackbar(tooltip);
                    }
                }
            }
        }
        this.updateAlertCount();
        event.preventDefault();
    }

    sourceRapidAlertAfterExecution() {
        if (UserSettings.get().enable_alerts && UserSettings.get().system_tray !== "N") {
            this.updateAlertCount();
        }
    }

    private updateAlertCount() {
        this.alertCount = this.sourceRapidAlert.data.filter(item => !item.get("is_read")).length;
        if (this.alertCount === 0 || !UserSettings.get().enable_alerts || UserSettings.get().system_tray === "N") {
            this.buttonNoNotificaiton.visible = true;
            this.buttonNotification.visible = this.labelNotificationNumber.visible = false;
            
            return;
        }
        else if (this.alertCount > 99) {
            this.buttonNotification.visible = this.labelNotificationNumber.visible = true;
            this.buttonNoNotificaiton.visible = false;
            this.alertCount = 99;
            this.labelNotificationNumber.text = "99+";
            this.labelNotificationNumber.marginLeft = "-29"
        }
        else {
            this.buttonNotification.visible = this.labelNotificationNumber.visible = true;
            this.buttonNoNotificaiton.visible = false;
            this.labelNotificationNumber.text = this.alertCount.toString();
            this.labelNotificationNumber.marginLeft = "-30"
        }
    }

    buttonRapidAlertFeedOnClick() {
        RapidAlertSlideout.showSlideout();
    }

    static async createForPageHeader(): Promise<RapidAlertFeed> {
        if (!AuthToken.isAuthenticated() || UserSettings.get() == null) {
            return null;
        }
        const layout = Layout.getLayout("lme/dispatch/RapidAlertFeed") as RapidAlertFeed;
        await layout.ensureLoaded();
        return layout.loadError == null ? layout : null;
    }
}
